<template>
  <div id="app">
    <header>
      <div class="container">
        <img src="@/assets/quest-logo.png" @click="drawerOpen = !drawerOpen" />
      </div>
    </header>
    <main>
      <div v-if="updateExists" class="update">
        An update is available
        <button class="active" @click="refreshApp">Update</button>
      </div>
      <router-view/>
    </main>
    <nav class="drawer" @click="drawerOpen = !drawerOpen" :class="{ 'show' : drawerOpen }">
      <ul>
        <li>
          <router-link to="/">
            <vue-fontawesome icon="coffee" size="2" color="#333333"></vue-fontawesome>
            Dashboard
          </router-link>
        </li>
        <li>
          <router-link to="/import">
            <vue-fontawesome icon="download" size="2" color="#333333"></vue-fontawesome>
            Import Survey
          </router-link>
        </li>
        <li>
          <router-link to="/sync">
            <vue-fontawesome icon="refresh" size="2" color="#333333"></vue-fontawesome>
            Sync Survey
          </router-link>
        </li>
        <li>
          <router-link to="/settings">
            <vue-fontawesome icon="cogs" size="2" color="#333333"></vue-fontawesome>
            Settings
          </router-link>
        </li>
      </ul>
      <div class="version">version: {{ version }}</div>
    </nav>
  </div>
</template>

<script>

import store from '@/store';
import update from '@/mixins/update';

export default {
  data() {
    return {
      online: navigator.onLine,
      drawerOpen: false,
    }
  },

  computed: {
    version() {
      return store.state.version;
    },

    count() {
      return store.state.count;
    }
  },

  mixins: [update]
}
</script>

<style lang="scss">
:root {
    --primary: #A0C22B;
    font: 400 60% Arial, sans-serif;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body {
    font-size: 1.6rem;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  margin: 0 auto;
  width: 100vw;
  height: 100vh;
  background-color: #eee;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  color: #2c3e50;
}

.container {
    margin: 0 auto;
    padding: 2rem;
    width: 90%;
}

header {
    width: 100%;
    height: 110px;
    background-color: white;
    color: white;
    font-size: 2rem;
    font-weight: 700;
    border-bottom: 1px solid var(--primary);
}

main {
    width: 100%;
    background-color: white;
    height: 100%;
}

.drawer {
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 200px;
  background-color: var(--primary);
  z-index: 5;
  cursor: pointer;
  transform: translateX(-170px);
  transition: 0.1s;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.show {
    transform: translateX(0);

    ul {
      opacity: 1;
    }
  }

  ul {
    display: flex;
    align-items: center;
    flex-direction: column;
    list-style: none inside none;
    padding-top: 30px;
    width: 200px;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;


    li {
      margin: 18px 0;
      width: 80%;

      a {
        display: flex;
        padding-bottom: 3px;
        color: #333;
        font-weight: 700;
        text-decoration: none;
        text-transform: uppercase;

        i {
          margin-right: 8px;
        }

        &:hover {
          transform: scale(1.08)
        }
      }
    }
  }

  .version {
    padding-bottom: 1rem;
    font-size: 1.4rem;
    text-align: center;
  }
}

.update {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #FFF;
  font-size: 2rem;
  font-weight: bold;
  background-color: rgba(0,0,0,.75);
  z-index: 20;
}

@media screen and (max-width: 900px) {
  .drawer {
    transform: translateX(-180px);
  }
}

</style>
